<template>
  <v-row>
    <v-col cols="12">
      <v-row class="green darken-3 white--text text-subtitle-1">
        <div class="pa-5 pl-10">
          <v-icon color="white" x-large class="blink_me">fa-file-contract</v-icon>
        </div>
        <v-col>
          <span class="pl-5 font-weight-bold text-h6 blink_me">E-Operating License</span>
          <br/>
          <span class="pl-5 font-weight-medium text-subtitle-1 blink_me">
            This is an official electronic operating license by Majlis Perbandaran Tawau.
          </span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="text-center" style="overflow: scroll">
      <v-btn
        icon
        color="primary"
        class="mr-5"
        :disabled="loading"
        @click="zoomOut"
      >
        <v-icon>fa-search-minus</v-icon>
      </v-btn>
      <v-btn
        icon
        color="primary"
        class="mr-5"
        :disabled="loading"
        @click="zoomIn"
      >
        <v-icon>fa-search-plus</v-icon>
      </v-btn>
      <v-card flat ref="canvasCard">
        <v-card-text>
          <div id="the-container" class="text-center">
            <canvas
              id="canvas"
              class="v-tabs-wrapper"
              style="border: 1px solid grey;"
              oncontextmenu="return false;"
              ref="canvas"
            >
              Canvas not supported
            </canvas>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>

<script>
/* eslint-disable no-unused-vars */
import vuex from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'DigitalLicenseOperating',
  async created () {
    await this.fetchData(this.$route.params)
    await this.generateDigitalLicense()

    window.addEventListener('orientationchange', this.renderPDF)
  },
  computed: {
    ...vuex.mapState({
      data: state => state.pdf.data
    })
  },
  data () {
    return {
      license: null,
      blob: null,
      currentPage: 1,
      loading: false,
      totalPages: 0,
      viewport: { width: 0, height: 0 },
      scale: null
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'pdf/fetchData',
      generateLicensePdf: 'pdf/generateLicensePdf'
    }),
    async generateDigitalLicense () {
      this.loading = true
      try {
        const params = await this.generateLicensePdf({
          origin: window.location.origin
        })
        const printWorker = new Worker(`print/license/${params.licenseType}.js`)
        printWorker.postMessage(params.licenseParams)
        printWorker.onmessage = function (response) {
          this.blob = URL.createObjectURL(response.data)
          this.renderPDF()
        }.bind(this)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$i18n.t('not_found'),
          visible: true
        })
        // this.$router.replace({ path: '/' })
      }
    },
    renderPDF: debounce(async function (scale) {
      if (!this.blob) return
      const pdfjsOption = { url: this.blob }
      const pdf = await pdfjsLib.getDocument(pdfjsOption).promise // eslint-disable-line
      this.totalPages = pdf.numPages
      const page = await pdf.getPage(this.currentPage)
      const container = document.getElementById('the-container')
      this.viewport = page.getViewport({ scale: 1 })
      if (!scale || typeof scale !== 'number') {
        this.scale = container.clientWidth / this.viewport.width
      }
      // if (this.scale < 1.3) this.scale = 1.3
      this.viewport = page.getViewport({ scale: this.scale })
      const canvas = document.getElementById(`canvas`)
      const context = canvas.getContext('2d')
      canvas.height = this.viewport.height
      canvas.width = this.viewport.width
      await page.render({
        canvasContext: context,
        viewport: this.viewport
      }).promise
      this.loading = false
    }, 300),
    zoomIn () {
      this.scale = this.scale + 0.25
      this.renderPDF(this.scale)
    },
    zoomOut () {
      if (this.scale <= 1.3) return
      this.scale = this.scale - 0.25
      this.renderPDF(this.scale)
    }
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.renderPDF)
  }
}
</script>

<style scoped>
.blink_me {
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% { opacity: 0.5; }
}
</style>
